import React from "react"
import PropTypes from "prop-types"
import style from "./Button.module.css"

const Button = props => {
  const {
    id,
    primary,
    secondary,
    outlined,
    contained,
    pressed,
    disabled,
    customClass,
    label,
    small,
    large,
  } = props
  // primary (default) secondary icon outlined contained
  let buttonStyle = secondary ? style.secondary : style.primary
  if (outlined) {
    buttonStyle = [buttonStyle, style.outlined].join(" ")
  }
  let containedStyle = secondary
    ? style.secondaryContained
    : style.primaryContained
  if (contained) {
    buttonStyle = [buttonStyle, containedStyle].join(" ")
  }

  return (
    <button
      id={id ? id : null}
      className={[buttonStyle, customClass].join(" ")}
      style={{
        height: small ? 32 : large ? 52 : 40,
        fontSize: small ? 14 : large ? 22 : 18,
        borderRadius: small ? 16 : large ? 26 : 20,
        padding: `0 ${small ? 16 : large ? 32 : 24}px`,
      }}
      onClick={pressed}
      disabled={disabled}
    >
      {/* {icon && (
        <img
          className={style.icon}
          src={props.icon}
          alt={props.children + " Button Icon"}
        />
      )} */}
      {label}
    </button>
  )
}

Button.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  pressed: PropTypes.func,
  fullWidth: PropTypes.bool,
  secondary: PropTypes.bool,
  contained: PropTypes.bool,
  outlined: PropTypes.bool,
  // icon: PropTypes.symbol,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
  small: PropTypes.bool,
  large: PropTypes.bool,
}

Button.defaultProps = {
  small: false,
  large: false,
}

export default Button
